import type { ReactNode } from 'react';

export const symbol_brunch_dining: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-160h570v50q0 12.75-8.62 21.37Q632.75-80 620-80H110q-12.75 0-21.37-8.63Q80-97.25 80-110v-50Zm0-64v-50q0-12.75 8.63-21.38Q97.25-304 110-304h182v-43q0-12.75 8.63-21.38Q309.25-377 322-377h86q12.75 0 21.38 8.62Q438-359.75 438-347v43h182q12.75 0 21.38 8.62Q650-286.75 650-274v50H80Zm664-120q-31-26-53.5-69T668-510v-340q0-12.75 8.63-21.38Q685.25-880 698-880h152q12.75 0 21.38 8.62Q880-862.75 880-850v340q0 54-22.5 97T804-344v204h46q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q862.75-80 850-80h-76q-12.75 0-21.37-8.63Q744-97.25 744-110v-234Zm-16-297h92v-179h-92v179Zm46 244q23-20 34.5-50.25Q820-477.51 820-510v-71h-92v71q0 32.49 11.5 62.75Q751-417 774-397Zm0 0Z"
		/>
	</svg>
);
